export const ANNOTATION_DEFAULTS = {
    queuedAnnotationIndex: 0,
    queuedAnnotationFromCarousel: false,
    queuedAnnotationFromLyricVerse: false,
}
